import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button, CircularProgress, Slide} from "@mui/material";
import {useEffect, useState} from "react";
import {Error} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import parameter from "../../../../../../enum/parameter";
import NotifyElectronicSignature from "./NotifyElectronicSignature";
import SkipSignature from "./SkipSignature";
import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import ElectronicSignatureTutorial from "../common/electronic-signature/ElectronicSignatureTutorial";

export default function ({interventionId}) {
    const [open, setOpen] = useState(false);
    const [openHelp, setOpenHelp] = useState(false);
    const [skipSignature, setSkipSignature] = useState(false);

    useEffect(() => {
        setTimeout(() => setOpen(true), 4000);
    }, []);

    const toggleOpenHelp = o => () => setOpenHelp(o);

    const handleSkip = () => {
        setSkipSignature(true);
        setOpenHelp(false);
    }

    return (
        <>
            <Body sx={{pb: 8}}>
                {
                    !skipSignature
                        ? (
                            <Slide in={open} direction={"up"}>
                                <div>
                                    <Box mt={4}>
                                        <NotifyElectronicSignature/>
                                    </Box>
                                    <Box
                                        mt={4}
                                        px={2}
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        <Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<Error/>}
                                            color={"error"}
                                            fullWidth
                                            onClick={toggleOpenHelp(true)}
                                            data-test="insurance-button-client-issue"
                                        >
                                            Le sociétaire rencontre un problème
                                        </Button>
                                    </Box>
                                </div>
                            </Slide>
                        )
                        : (
                            <Box mt={5} px={2}>
                                <SkipSignature interventionId={interventionId}/>
                            </Box>
                        )
                }
                {
                    openHelp
                        ? (
                            <Modal
                                modalConfig={
                                    new ModalConfig()
                                        .setWidth("100%")
                                        .setHeight("100%")
                                        .setOnClose(toggleOpenHelp(false))
                                        .setComponent(
                                            <ElectronicSignatureTutorial
                                                onSkip={handleSkip}
                                                skipMessage={"Passer le PV"}
                                            />
                                        )
                                }
                            />
                        )
                        : null
                }
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={true}
                    data-test="insurance-button-waiting-signature"
                >
                    <CircularProgress size={20} color={"inherit"}/>
                    <Typography display="inline">
                        &nbsp;Attente de {skipSignature ? "confirmation" : "signature"}
                    </Typography>
                </Button>
            </Footer>
        </>
    );
}
